import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import ServicesSection from "@/components/ServicesSection";
import BlogSection from "@/components/BlogSection";
import SustainabilitySection from "@/components/SustainabilitySection";
import QuoteSection from "@/components/QuoteSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { pageMeta } from "@/seo/pageMeta";

const Index = () => {
  return (
    <div className="min-h-screen">
      <SEO
        title={pageMeta.home.title}
        description={pageMeta.home.description}
        path="/"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Envir AS",
            url: "https://envir.com",
            address: {
              "@type": "PostalAddress",
              addressLocality: "Bergen",
              addressCountry: "NO",
            },
          },
          {
            "@context": "https://schema.org",
            "@type": "RecyclingCenter",
            name: "Envir AS",
            url: "https://envir.com",
            telephone: "+47 55 99 25 00",
            email: "post@envir.no",
            address: {
              "@type": "PostalAddress",
              streetAddress: "Damsgårdsveien 165",
              addressLocality: "Bergen",
              postalCode: "5160",
              addressCountry: "NO",
            },
            areaServed: "NO",
            openingHoursSpecification: [
              {
                "@type": "OpeningHoursSpecification",
                dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
                opens: "07:00",
                closes: "16:00",
              },
            ],
          },
        ]}
      />
      <Navbar />
      <HeroSection />
      <ServicesSection />
      <AboutSection />
      <QuoteSection />
      <BlogSection />
      <SustainabilitySection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default Index;
